module.exports = __webpack_public_path__ + "img/transportation_disabled.801e11dc.svg";